import { hasGradableWidget } from '../../application/utils/hasGradableWidget';
import { ValidationStatus, ValidationType } from './types';
import { ensureNotUndefined, isBlindMapQuestion, isQuestion, Item, Quiz } from '@ael/core-api';
import { List } from 'immutable';

export class QuizValidator {
  public static isValid(item: Quiz, items?: List<Item>) {
    return this.validate(item, items).length === 0;
  }
  public static validate(item: Quiz, items?: List<Item>): ValidationStatus[] {
    const validations = [];

    if (item.contentItems.isEmpty()) {
      validations.push({
        type: ValidationType.Error,
        message: 'Quiz has no items.',
        item,
        itemName: item.title ?? 'Unknown title', // This is always known! as there is a default in every Item
      });
    }

    if (items && !item.contentItems.isEmpty()) {
      if (
        item.contentItems
          .map((itemId: string) => items.find((i) => i?.id === itemId))
          .filter((i: Item | undefined) => {
            ensureNotUndefined(i);
            return isBlindMapQuestion(i) || (isQuestion(i) && hasGradableWidget(i));
          }).size === 0
      ) {
        validations.push({
          type: ValidationType.Error,
          message: 'Quiz does not contain any valid questions.',
          item,
          itemName: item.title ?? 'Unknown title', // This is always known! as there is a default in every Item
        });
      }
    }

    return validations;
  }
}
